import { render, staticRenderFns } from "./micoapp_form.vue?vue&type=template&id=8b0c5694"
import script from "./micoapp_form.vue?vue&type=script&lang=js"
export * from "./micoapp_form.vue?vue&type=script&lang=js"
import style0 from "./micoapp_form.vue?vue&type=style&index=0&id=8b0c5694&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports